import type { NdcSwitchConfigV2 } from '../../types/drug-config';

export type SwitchDeviceDescriptions = {
    currentDevice: string;
    targetDevice: string;
};

export const getSwitchDeviceDescriptions = (
    switchConfig: NdcSwitchConfigV2 | undefined,
    requestedNdc: string | null
): SwitchDeviceDescriptions => {
    const pathwayConfigs = Object.values(switchConfig ?? {}).flatMap(
        (configs) => configs ?? []
    );

    return {
        currentDevice: pathwayConfigs[0]?.source.description ?? '',
        targetDevice:
            pathwayConfigs
                .flatMap((config) => config.targets)
                .find((target) => target.ndc === requestedNdc)?.description ??
            '',
    };
};

export const resolveReasonContent = <T>(
    content: T[] | Partial<Record<string, T[]>> | undefined,
    reason: string | null | undefined
): T[] | undefined => {
    if (!content) {
        return undefined;
    }

    if (Array.isArray(content)) {
        return content;
    }

    return (reason ? content[reason] : undefined) ?? content['self-pay'];
};
